export const MSG_SUBSCRIBE = '{"message":"subscribe","action":"%s"}';
export const MSG_UNSUBSCRIBE = '{"message":"unsubscribe","action":"%s"}';
export const MSG_SUBSCRIBE_REGEX = /^{"message":"(un)?subscribe","action":"([^"]+)"}$/;

export const msg = (what: string, text: string) =>
  what.replace('%s', text.replace(/\\([\s\S])|(")/g, '\\$1$2'));
